// src/pages/Dashboard/Finance/Payroll/TotalAppointments.jsx
import React from "react";
import { Grid, Paper, Box, Typography } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { useTranslation } from "react-i18next";

const TotalAppointments = ({ appointmentData = {} }) => {
  const { t } = useTranslation();
  const data = [
    {
      name: t("finance.totalPendingAppointments"),
      value: Number(appointmentData.total_pending_appointments) || 0,
    },
    {
      name: t("finance.totalPendingFees"),
      value: Number(appointmentData.total_pending_fees) || 0,
    },
    {
      name: t("finance.totalRevenueFromAppointments"),
      value: Number(appointmentData.total_revenue_from_appointments) || 0,
    },
  ];

  return (
    <Grid container>
      <Paper sx={{ width: "100%", padding: 3, borderRadius: 2, boxShadow: 3 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            {t("finance.appointmentOverview")}
          </Typography>
        </Box>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.3} />
            <XAxis dataKey="name" tick={{ fill: "#555", fontWeight: "bold" }} />
            <YAxis tick={{ fill: "#555", fontWeight: "bold" }} />
            <Tooltip />
            <Legend verticalAlign="top" align="right" iconType="circle" />
            <Bar dataKey="value" fill="#1976d2" barSize={30} radius={[4, 4, 0, 0]} name={t("finance.value")} />
          </BarChart>
        </ResponsiveContainer>
      </Paper>
    </Grid>
  );
};

export default TotalAppointments;
